const isStudentAllowedToViewDiscussionLink = (studentId) => {
  const notAllowedStudentIds = []

  return !notAllowedStudentIds.includes(studentId)
}

export {
  isStudentAllowedToViewDiscussionLink
}
